export type IdentityLike = {
  name?: string | null
  email?: string | null
}

function titleCase(value: string): string {
  return value
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ')
}

export function displayNameFromEmail(email = ''): string {
  const local = String(email || '').split('@')[0] || ''
  const readable = titleCase(local.replace(/[._-]+/g, ' '))
  return readable || String(email || '')
}

export function getDisplayName(identity?: IdentityLike | string | null): string {
  if (!identity) return 'Unknown user'
  if (typeof identity === 'string') {
    return identity.includes('@') ? displayNameFromEmail(identity) : titleCase(identity)
  }
  const explicit = String(identity.name || '').trim()
  if (explicit && !explicit.includes('@')) return explicit
  return displayNameFromEmail(identity.email || explicit)
}

export function getInitialsFromIdentity(identity?: IdentityLike | string | null): string {
  const name = getDisplayName(identity)
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join('') || 'U'
}

export function formatIdentityList(names: unknown, emails: unknown): Array<{name: string; email: string; initials: string}> {
  const nameList = Array.isArray(names) ? names : [names].filter(Boolean)
  const emailList = Array.isArray(emails) ? emails : [emails].filter(Boolean)
  const length = Math.max(nameList.length, emailList.length)

  return Array.from({length}, (_, index) => {
    const email = String(emailList[index] || '')
    const rawName = String(nameList[index] || '')
    const name = getDisplayName({name: rawName, email})
    return {
      name,
      email,
      initials: getInitialsFromIdentity({name, email}),
    }
  })
}
